import React from "react";
import {DatePicker, Form, Input, message, Modal, Select} from "antd";
import {UserGet, UserUpdate} from "../../../../models/employee";

const moment = require('moment');

const FormItem = Form.Item;
const Option = Select.Option;
const { TextArea } = Input;

class UpdateEmployeeForm extends React.Component {
  state = {};
  handlePopupAfterAddUpdate = () => {
    this.props.fetch();
    this.props.setModelVisible()
  };
  handleUpdate = (id) => {
    const form = this.props.form;
    form.validateFields((err, values) => {
      if (!err) {
        if (values['dob'])
          values['dob'] = moment(values['dob']).format('YYYY-MM-DD');
        if (values['date_hired'])
          values['date_hired'] = moment(values['date_hired']).format('YYYY-MM-DD');
        if (values['end_date'])
          values['end_date'] = moment(values['end_date']).format('YYYY-MM-DD');
        UserUpdate(id, values)
          .then(response => {
            this.setState({
              visible: false,
              value: { key: response.id, label: response.name }
            });
            message.success('Employee updated successfully');
            form.resetFields();
            this.handlePopupAfterAddUpdate()
          });
      }
    });
  };

    onRowUpdateClick = (id) => {
        UserGet(id)
            .then(response => {
                this.props.form.setFieldsValue({
                    first_name: response.data.first_name,
                    last_name: response.data.last_name,
                    user_type: response.data.user_type,
                    dob: response.data.dob ? moment(response.data.dob) : null,
                    date_hired: response.data.date_hired ? moment(response.data.date_hired) : null,
                    expertise: response.data.expertise,
                    emp_id: response.data.emp_id,
                    end_date: response.data.end_date ? moment(response.data.end_date) : null,
                });
            });
    };

  componentDidMount() {
    this.onRowUpdateClick(this.props.moderated)
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { moderated, visible } = this.props;
    return (
      <Modal title="Update Employee" centered width={"60%"} visible={visible} onOk={() => this.handleUpdate(moderated)}
        okText="Update Employee" onCancel={() => this.props.setModelVisible()} destroyOnClose={true}>
        <div className="col-xs-12 paddingZ add-item-inner floating-form">
          <Form>
            <div className="row">
              <div className="floating-label">
                <FormItem label="Employee Id">
                  {getFieldDecorator('emp_id', {
                    rules: [{ required: true, message: 'Please input Employee ID' }],
                  })(<Input placeholder="Enter Employee ID" />)}
                </FormItem>
              </div>
              <div className="floating-label">
                <FormItem label="First Name">
                  {getFieldDecorator('first_name', {
                    rules: [{ required: true, message: 'Please input first name' }],
                  })(<Input placeholder="Enter first name" />)}
                </FormItem>
              </div>
              <div className="floating-label">
                <FormItem label="Last Name">
                  {getFieldDecorator('last_name', {
                    rules: [{ required: true, message: 'Please input last name' }],
                  })(<Input placeholder="Enter last name" />)}
                </FormItem>
              </div>
              <div className="floating-label">
                <FormItem label="User Name">
                  {getFieldDecorator('user_type', {
                    rules: [{ required: true, message: 'Please input user type' }],
                  })(<Select showSearch style={{ width: "100%" }} placeholder="User Type">
                    <Option value="admin">Admin</Option>
                    <Option value="laborer">LABORER</Option>
                    <Option value="driver">Driver</Option>
                  </Select>)}
                </FormItem>
              </div>
              <div className="floating-label">
                <FormItem label="DOB">
                  {getFieldDecorator('dob')(<DatePicker className="cal-dob" placeholder="Enter Date of birth" />)}
                </FormItem>
              </div>
              <div className="floating-label">
                <FormItem label="Date Of Hired">
                  {getFieldDecorator('date_hired')(<DatePicker className="cal-dob" placeholder="Enter Date of hired" />)}
                </FormItem>
              </div><div className="floating-label">
                <FormItem label="Date of ending job">
                  {getFieldDecorator('end_date')(<DatePicker className="cal-dob" placeholder="Enter Date of ending job" />)}
                </FormItem>
              </div>
              <div className="floating-label">
                <FormItem label="Expertise">
                  {getFieldDecorator('expertise', {
                    rules: [{ required: true, message: 'Please input expertise ' }],
                  })(<TextArea placeholder="Enter Expertise" rows={3} />)}
                </FormItem>
              </div>
            </div>
          </Form>
        </div>
      </Modal>
    )
  }
}

export const UpdateEmployee = Form.create()(UpdateEmployeeForm);


// WEBPACK FOOTER //
// ./src/pages/analytics/employee_profile/popups/UpdateEmployee.jsx